import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { ExternalJobDisplayInputDto } from '../models/external-job-display-input.dto';
import { combine } from '../utilities/route';
import { ExternalJobDisplayPayIntroDto } from 'src/app/shared/models/external-job-display-pay-intro.dto';
import { formatCurrency } from '@angular/common';
import { Lookup } from '../models/lookup.model';
import { ExternalJobDisplayPayIntrosEnum } from 'src/app/accountmanagers/jobs/enums/external-job-display-pay-intros-enum';

@Injectable({ providedIn: 'root' })
export class ExternalJobDisplayService {
    private readonly _coreApiPath: string;

    constructor(
        @Inject(APP_CONFIG) settings: Settings,
        private readonly _httpClient: HttpClient
    ) {
        this._coreApiPath = combine(settings.coreAPIUrl, 'ayanova/ExternalJobDisplay');
    }

    save(externalInfo: ExternalJobDisplayInputDto): Observable<boolean> {
        return this._httpClient.post<boolean>(`${this._coreApiPath}`, externalInfo);
    }

    get(jobIds: number[]): Observable<ExternalJobDisplayInputDto> {
        return this._httpClient.post<ExternalJobDisplayInputDto>(`${this._coreApiPath}/get-display-options`, jobIds);
    }

    getPayIntros(): Observable<ExternalJobDisplayPayIntroDto[]> {
        return this._httpClient.get<ExternalJobDisplayPayIntroDto[]>(`${this._coreApiPath}/get-pay-intros`);
    }

    clear(jobIds: number[]): Observable<any> {
        const options = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
            body: jobIds
        };
        return this._httpClient.delete<any>(`${this._coreApiPath}`, options);
    }

    updatePayFormatDisplay(
        externalJobDisplayPayIntros: ExternalJobDisplayPayIntroDto[],
        payShiftTypes: Lookup[],
        displayConfigData: ExternalJobDisplayInputDto
    ): string {
        const intro = externalJobDisplayPayIntros.find(
            (i) => i.externalJobDisplayPayIntroId === displayConfigData.payIntroId
        );

        const payShiftType = payShiftTypes.find((p) => p.id === displayConfigData.payShiftId);
        const introText = intro?.externalJobDisplayPayIntroId > 1 ? intro?.name : '';
        const valueText = formatCurrency(Number(displayConfigData.payRate), 'en-US', '$', 'symbol', '1.2-2');
        const valueTextTo = formatCurrency(Number(displayConfigData.payRateTo), 'en-US', '$', 'symbol', '1.2-2');

        if (intro?.externalJobDisplayPayIntroId === ExternalJobDisplayPayIntrosEnum.Range) {
            return `${valueText} to ${valueTextTo} ${payShiftType?.name.toLowerCase() ?? ''}`.trim();
        } else {
            return `${introText} ${valueText} ${payShiftType?.name.toLowerCase() ?? ''}`.trim();
        }
    }
}
